import React from "react";
import { useFavoriteTournaments } from "../common/favorite-tournaments/FavoriteTournamentsProvider";
import ContentWrapper from "../common/ContentWrapper";
import Img from "../common/Img";
import { usePrematchData } from "./PrematchDataFetcher";
import InfoMessage from "../common/InfoMessage";
import TournamentFetcher from "./TournamentFetcher";
import Tournament from "./Tournament";
import { getLabel } from "../InitData";

export default function Favorites() {
    const prematchData = usePrematchData();
    const favorites = useFavoriteTournaments();

    const tournaments = [];
    Object.keys(favorites).forEach(uniqueId => {
        const t = prematchData.tournamentByUniqueId[uniqueId];
        if (t != null) {
            tournaments.push(t);
        }
    });

    return (
        <>
            <ContentWrapper columns="1">
                <div className="c_44">
                    {/* <div className={"c_44_1 " + props.icon}></div> */}
                    <Img className="c_44_1" src="Favs_default.svg" height="16px" width="16px" />
                    <div className="c_44_2">{getLabel('general.preferiti')}</div>
                </div>
                {tournaments.length === 0 &&
                    <InfoMessage text={getLabel('general.preferiti.specs')} />
                }
                {tournaments.map(tournament =>
                    <TournamentFetcher key={tournament.uniqueId} data={tournament} renderItem={(data) =>
                        <Tournament data={data} />
                    } />
                )}
            </ContentWrapper>
        </>
    );
}
